import { createContext, useContext, useEffect, useMemo, useState } from 'react'
import { CssBaseline, ThemeProvider } from '@mui/material'
import { buildAppTheme } from '../theme'

const STORAGE_KEY = 'happyears-theme-mode'

const ThemeModeContext = createContext({ mode: 'light', toggleMode: () => { } })

export const useThemeMode = () => useContext(ThemeModeContext)

export const AppThemeModeProvider = ({ children }) => {
    // Default to light mode unless the user previously picked dark mode.
    const [mode, setMode] = useState(() => {
        const stored = localStorage.getItem(STORAGE_KEY)
        return stored === 'dark' ? 'dark' : 'light'
    })

    const toggleMode = () => {
        setMode((prev) => (prev === 'light' ? 'dark' : 'light'))
    }

    useEffect(() => {
        // Keep both localStorage and the DOM attribute in sync for reloads and non-React consumers.
        localStorage.setItem(STORAGE_KEY, mode)
        document.documentElement.setAttribute('data-theme-mode', mode)
    }, [mode])

    const theme = useMemo(() => buildAppTheme(mode), [mode])

    return (
        <ThemeModeContext.Provider value={{ mode, toggleMode }}>
            <ThemeProvider theme={theme}>
                <CssBaseline />
                {children}
            </ThemeProvider>
        </ThemeModeContext.Provider>
    )
}
